import script from "./block-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./block-editor.vue?vue&type=script&setup=true&lang=ts"

import "./block-editor.vue?vue&type=style&index=0&id=9bcfde1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bcfde1a"]])

export default __exports__